import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';

import {
  NumberWidget,
  HeatMapWidget,
  ListWidget, LabelWidget,
} from '../../widgets';

const Summary = ({
  title,
  map,
  uniqueViewers,
  uniqueDevices,
  bitrate,
  avgLates,
  topChannels,
  topShows,
  topSvod,
  topTvod,
  topDevices,
}) => (
  <div className="dashboard">
    <Grid columns={5} rows="20px 220px minmax(70%, 90%)" alignContent="stretch" style={{ height: '100%' }}>
      <Cell width={5}>
        <LabelWidget input={{ data: { title } }} />
      </Cell>
      <Cell>
        <HeatMapWidget input={map} />
      </Cell>
      <Cell>
        <NumberWidget input={uniqueViewers} />
      </Cell>
      <Cell>
        <NumberWidget input={uniqueDevices} />
      </Cell>
      <Cell>
        <NumberWidget input={bitrate} />
      </Cell>
      <Cell>
        {
          (
            avgLates ? (
              <NumberWidget input={avgLates} />
            ) : (
              <div />
            )
          )
        }
      </Cell>
      <Cell>
        <ListWidget input={topChannels} />
      </Cell>
      <Cell>
        <ListWidget input={topShows} />
      </Cell>
      <Cell>
        <ListWidget input={topSvod} />
      </Cell>
      <Cell>
        <ListWidget input={topTvod} />
      </Cell>
      <Cell>
        <ListWidget input={topDevices} />
      </Cell>
    </Grid>
  </div>
);

Summary.defaultProps = null;

Summary.propTypes = {
  title: PropTypes.string,
  map: PropTypes.shape(HeatMapWidget.propTypes),
  uniqueViewers: PropTypes.shape(NumberWidget.propTypes),
  uniqueDevices: PropTypes.shape(NumberWidget.propTypes),
  bitrate: PropTypes.shape(NumberWidget.propTypes),
  avgLates: PropTypes.shape(NumberWidget.propTypes),
  topChannels: PropTypes.shape(ListWidget.propTypes),
  topShows: PropTypes.shape(ListWidget.propTypes),
  topSvod: PropTypes.shape(ListWidget.propTypes),
  topTvod: PropTypes.shape(ListWidget.propTypes),
  topDevices: PropTypes.shape(ListWidget.propTypes),
};

export default Summary;
